import React,  {useRef} from 'react'
import {useStore} from 'react-hookstore'
import {FetchHtmlText} from './FetchHtmlText'

export default function Modal() {
  const [modal, setModal] = useStore('modal')
  const node = useRef(<div/>)
  const handleClickOutside = e => {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    if(modal.open === 'modal-open') {
      modalClose()
    }
  }
  const modalClose = () => {
    setModal(modal => ({...modal, open:'modal-close'}))
    document.body.style.overflow = 'visible'
  }
  let label = null || modal.label
  document.addEventListener("mousedown", handleClickOutside)
  return(<>
    <div ref={node} className={`modal-content ${modal.open}`}>
      <div className='modal-header' onClick={() => modalClose()}>
        <div>
          {modal.title}
          <span onClick={() => modalClose()} className='closemodal'>&times;</span>
        </div>
      </div>
      <div className='modal-body'>
        <FetchHtmlText>label</FetchHtmlText>
        {modal.body}
      </div>
    </div>
  </>
  )
}
